<template>
  <div>
    <v-img
      src="https://alaqeelah.sy/assets/images/logo nav.png"
      max-width="100%"
      contain
    ></v-img>
  </div>
</template>

<script>
export default {
  // You can add component options here, like data, methods, computed properties, etc.
};
</script>

<style>
/* Add component-specific styles here */
</style>
